import {Flex, Title, Text} from '@priority-software/priority-style-react';
import React from 'react';
import ChartExplanationRenderer from './ChartExplanationRenderer';
import texts from '../../../texts';
import {getHelpData} from '../../../utils';
import {HyperlinkText} from '../../../../../components/Common/LinkTexts/LinkTexts';

const ChartAxesInfo = ({chartInfo}) => {
    const helpData = getHelpData(texts[chartInfo.type + 'Info']);
    return (
        <div>
            <Flex alignItems="center" justifyContent="center">
                <ChartExplanationRenderer chartType={chartInfo.type} />
            </Flex>
            <Title skin="h5" fontWeight="semi-bold" style={{display: 'flex'}}>
                {texts[chartInfo.type + 'Header']}
            </Title>
            <Text style={{width: '40rem'}} skin="paragraph-2">
                <HyperlinkText
                    text={helpData.content}
                    linkData={helpData.linkList}
                    onLinkClick={helpData.onLinkClick}
                />
            </Text>
        </div>
    );
};

export default ChartAxesInfo;
